<template>
    <div>
        <!-- 奖品列表表格：审核详情页共用（创建审核奖品展示 / 编辑审核奖品对比） -->
        <el-table :data="prizes" border size="small" stripe>
            <!-- 变动标识（新增/删除） -->
            <el-table-column v-if="tagText" label="标识" width="70" align="center">
                <template>
                    <el-tag :type="tagType" size="mini">{{ tagText }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="prizeItem" label="奖项" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="奖品类型" width="90">
                <template slot-scope="{row}">{{ row.prizeType == 1 ? '优惠券' : '自定义奖品' }}</template>
            </el-table-column>
            <el-table-column prop="prizeInfo" label="奖品内容" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="自动发奖" width="80">
                <template slot-scope="{row}">{{ row.autoSendReward == 1 ? '是' : '否' }}</template>
            </el-table-column>
            <el-table-column label="自动发放排名" min-width="120">
                <template slot-scope="{row}">{{ row.autoSendReward == 1 ? `第${row.autoSendStartRank || '-'}名 至 第${row.autoSendEndRank || '-'}名` : '-' }}</template>
            </el-table-column>
            <el-table-column label="自动发放时间" min-width="150">
                <template slot-scope="{row}">{{ row.autoSendReward == 1 ? formatTime(row.autoSendTime) : '-' }}</template>
            </el-table-column>
            <el-table-column label="信息收集截止时间" min-width="150">
                <template slot-scope="{row}">{{ formatTime(row.awardDeadline) }}</template>
            </el-table-column>
            <el-table-column label="信息收集" min-width="180" show-overflow-tooltip>
                <template slot-scope="{row}">{{ formatCollectInfos(row.collectInfo) }}</template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
export default {
    name: 'ShareActivityPrizeTable',
    props: {
        // 奖品数组
        prizes: {
            type: Array,
            default: () => []
        },
        // 变动标识文案（新增/删除），不传则不展示标识列
        tagText: {
            type: String,
            default: ''
        },
        // 变动标识 tag 类型
        tagType: {
            type: String,
            default: 'info'
        }
    },
    methods: {
        
        // 时间格式化：兼容时间戳（10-13位纯数字，10 位为秒级需转毫秒）与已格式化字符串，无值显示 '-'（与审核详情页 formatTime 逻辑一致）
        formatTime(val) {
            if (!val) return '-';
            if (/^\d{10,13}$/.test(String(val))) {
                const _num = Number(val);
                return this.$utils.formatDate(String(val).length == 10 ? _num * 1000 : _num, 'yyyy-MM-dd HH:mm:ss');
            }
            return val;
        },
        // 信息收集转文本描述
        formatCollectInfos(infos) {
            // 兼容 JSON 字符串形式（审核详情快照可能序列化存储），解析失败视为无信息
            if (typeof infos == 'string' && infos.trim()) {
                try {
                    infos = JSON.parse(infos);
                } catch (e) {
                    infos = null;
                }
            }
            if (!Array.isArray(infos) || !infos.length) return '无需收集信息';
            return infos.map(item => {
                if (item.question != undefined) {
                    return `问题：${item.question}`;
                }
                if (item.chooseItems != undefined) {
                    return `选项组：${item.chooseTitle || ''}（${(item.chooseItems || []).join('、')}）`;
                }
                return '';
            }).filter(v => v).join('；');
        }
    }
};
</script>
